export default "__VITE_ASSET__Dh9DV9TC__"